<template>
  <div class="container-lg clearfix px-2">
    <form>
      <div class="form-checkbox">
        <label>
          <input
            type="checkbox"
            :checked="showLocation"
            @input="updateShowLocation"
            aria-describedby="help-text-for-location"
          />
          Show my location on the hydrant map.
        </label>
        <p class="note" id="help-text-for-location">
          This will attempt to show your phone's approximate location on the
          hydrant map. Your current location is not transmitted or stored
          anywhere.
        </p>
      </div>
      <div class="form-checkbox">
        <label>
          <input
            type="checkbox"
            :checked="showMuniHydrants"
            @input="updateShowMuniHydrants"
            aria-describedby="help-text-for-muni-hydrants"
          />
          Show municipal hydrants on the hydrant map.
        </label>
        <p class="note" id="help-text-for-muni-hydrants">
          This will show hydrants marked as municipal hyrants on the map. Hiding
          them can help declutter the map.
        </p>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: "SettingsView",
  components: {},
  computed: {
    showLocation() {
      return this.$store.state.showLocation;
    },
    showMuniHydrants() {
      return this.$store.state.showMuniHydrantsV2;
    },
    locationDisplay() {
      return this.showLocation() ? "on" : "off";
    },
    locationAction() {
      return this.showLocation() ? "Disable" : "Enable";
    },
    muniHydrantsDisplay() {
      return this.showMuniHydrants() ? "yes" : "no";
    },
    muniHydrantsAction() {
      return this.showMuniHydrants() ? "Disable" : "Enable";
    }
  },
  methods: {
    updateShowLocation() {
      this.$store.dispatch("toggleShowLocation");
    },
    updateShowMuniHydrants() {
      this.$store.dispatch("toggleShowMuniHydrants");
    }
  }
};
</script>
